import userReducer from "../features/user/userSlice";
import providerReducer from "../features/provider/providerSlice";
import uploadDocumentReducer from "../features/upload-documents/uploadDocumentSlice";
import conditionReducer from "../features/conditions/conditionSlice";
import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query'
import {apiCore, apiCoreV2} from "../features/apiSlice/apiCore";

export const store = configureStore({
    reducer: {
        userSlice: userReducer,
        providerSlice: providerReducer,
        uploadDocumentSlice: uploadDocumentReducer,
        conditionSlice: conditionReducer,

        // RTK reducers
        [apiCore.reducerPath]: apiCore.reducer,
        [apiCoreV2.reducerPath]: apiCoreV2.reducer,
    },
    middleware: getDefaultMiddleware => [
        ...getDefaultMiddleware({
            serializableCheck: false,
        }).concat([apiCore.middleware,apiCoreV2.middleware]),
    ],
    devTools: process.env.NODE_ENV === 'development',
});

setupListeners(store.dispatch)